import React from 'react'

const DiscountVoucherButton = ({ id, functionParams }) => {
  if (!functionParams || functionParams.length < 1) return null
  const [voucherLink, location = 'none'] = functionParams
  return (
    <span id={id}>
      <a data-location={location} onClick={(e) => window.handleApplyDiscountClick(e, voucherLink)} className='btn btn-warning discountVoucherLink' href={voucherLink}>
        Apply discount
      </a>
    </span>
  )
}

export default DiscountVoucherButton



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/discountVoucherButton.jsx